import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry } from '@app/sentry';
import { Providers } from '@app/Providers';
import { AppRouter } from '@app/router';
import i18n from '@i18n/index';
import { initHostUnitSystemSync } from '@services/hostUnitSystemSync';
import { startVersionCheck } from '@utils/versionChecker';
import { useToastStore } from '@stores/toastStore';
import './index.css';

// Default theme = dark. Future: read from user preference / system query.
document.documentElement.classList.add('light');

initSentry();
initHostUnitSystemSync();

// 版本检测：轮询 version.json，检测到新版本后弹出常驻 toast 提示刷新（dev 模式内部跳过）
startVersionCheck(() => {
  useToastStore.getState().addToast(i18n.t('common.newVersionDetected'), 'warning', {
    duration: Infinity,
    action: {
      label: i18n.t('common.refreshNow'),
      onClick: () => window.location.reload(),
    },
  });
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Providers>
      <AppRouter />
    </Providers>
  </React.StrictMode>,
);
